






























































































import { computed, defineComponent } from '@nuxtjs/composition-api'
import { defineComponentTranslations } from '~/utils/i18n'
import CodeHighlight from '~/components/shared/configurable/CodeHighlight.vue'
import { useI18n } from '~/compositions/i18n'
import { xmlDeclarationCode, xmlMainCode, xsdCode } from '~/constants/xml'

export default defineComponent({
  components: { CodeHighlight },
  layout: 'xml-layout',
  setup() {
    const { t } = useI18n()
    const tableData = computed(() => [
      {
        cell1: t('vehicles'),
        cell2: t('full_support'),
        cell3: t('only_bicycles')
      },
      {
        cell1: t('parts'),
        cell2: t('fully_supported'),
        cell3: t('supported_without_brand_model')
      },
      {
        cell1: t('small classifieds'),
        cell2: t('yes'),
        cell3: t('yes')
      },
      {
        cell1: t('category_mapping'),
        cell2: t('in_advance'),
        cell3: t('done_afterwards')
      },
      {
        cell1: t('implementation_cost'),
        cell2: t('custom_implementation'),
        cell3: t('ready_and_operating')
      }
    ])

    return {
      xmlMainCode,
      xmlDeclarationCode,
      tableData,
      xsdCode
    }
  },

  i18n: defineComponentTranslations({
    xml_specifications: {
      en: 'Xml Specifications',
      el: 'Προδιαγραφές XML'
    },
    standard_title: {
      en: 'What standard should I choose?',
      el: 'Τι πρότυπο να επιλέξω;'
    },
    standard_description: {
      en:
        'Car.gr can accept two types of standards, the Car.gr XML and the General Commerce XML. The choice depends on the type of catalog you have and the capabilities you want to use. Below is a summary table of the differences to help you make your choice.',
      el:
        'Το car.gr μπορεί να δεχτεί 2 ειδών πρότυπα, το Car.gr XML και XML γενικού εμπορίου. Το ποιο θα επιλέξετε εξαρτάται από το τι είδους κατάλογο έχετε και τι δυνατότητες θέλετε να χρησιμοποιήσετε. Ακολουθεί ένας συνοπτικός πίνακας με τις διαφορές για να σας βοηθήσει να επιλέξετε.'
    },
    summary: {
      en: 'In summary, the XML file should meet the following specifications:',
      el:
        'Συνοπτικά, θα πρέπει το αρχείο XML να πληρεί τις παρακάτω προδιαγραφές:'
    },

    encoding: {
      en: 'It should specify the encoding.',
      el: 'Να καθορίζει το encoding.'
    },
    time_and_date_info: {
      en:
        'Information about the time and date of the last modification should be included.',
      el:
        'Να υπάρχει η πληροφορία για την ώρα και ημερομηνία τελευταίας τροποποίησης.'
    },
    w3_standards: {
      en:
        'It should be valid according to the w3 standards (you can check it <a href="https://validator.w3.org/">here</a>).',
      el:
        'Να είναι valid σύμφωνα με τα πρότυπα w3 (μπορείτε να το ελέγξετε <a href="https://validator.w3.org/">εδώ</a>).'
    },
    unique_id: {
      en: 'Each classified should have its own unique ID.',
      el: 'Η κάθε αγγελία να έχει το δικό της, μοναδικό unique ID.'
    },
    vat: {
      en: 'The prices mentioned should include the VAT.',
      el: 'Να περιλαμβάνει τον Φ.Π.Α. στις τιμές που αναφέρονται.'
    },
    xml_accepted: {
      en:
        'For the XML to be accepted, it must contain all the mandatory fields that meet the specifications as defined below. If the initial XML is valid but a field is added in the future that does not meet the specifications, then the import of products stops at the product that contains the invalid field and does not continue to subsequent products.',
      el:
        'Για να μπορεί να γίνει δεκτό το XML θα πρέπει να περιέχει όλα τα υποχρεωτικά πεδία που πληρούν τις προδιαγραφές όπως αυτές ορίζονται παρακάτω. Σε περίπτωση που είναι έγκυρο το αρχικό XML, αλλά μελλοντικά εισαχθεί κάποιο πεδίο που δεν πληρεί τις προδιαγραφές, τότε η εισαγωγή προϊόντων σταματά στο προϊόν που περιλαμβάνει το μη έγκυρο πεδίο και δεν συνεχίζει σε επόμενα προϊόντα.'
    },
    encoded: {
      en:
        'The XML should be encoded in UTF-8. The lastupdate field indicates the date of the last modification of the XML in ISO 8601 format (see  <a href="https://en.wikipedia.org/wiki/ISO_8601" target="_blank" rel="nofollow">here</a> for details on the date format). Below is an example of how the file should start:',
      el:
        'Το XML θα πρέπει να είναι κωδικοποιημένο σε UTF-8. Το πεδίο ημερομηνίας τροποποίησης (πεδίο lastupdate) δείχνει την ημερομηνία της τελευταίας τροποποίησης του XML σε μορφή ISO 8601 (δείτε <a href="https://en.wikipedia.org/wiki/ISO_8601" target="_blank" rel="nofollow">εδώ</a> λεπτομέρειες για τη μορφή ημερομηνίας). Παρακάτω μπορείτε να δείτε ένα παράδειγμα για το πώς πρέπει να ξεκινά το αρχείο.'
    },
    note: {
      en:
        'Note: If the lastupdate field is not updated with the modification date of the file, product updates will not be processed. This field indicates that there is some update in the products and should not always have the current date. It should reflect the date of modification for product changes.',
      el:
        'Σημείωση: Σε περίπτωση που δεν ενημερώνεται το πεδίο lastupdate με την ημερομηνία τροποποίησης του αρχείου, δεν θα γίνεται ενημέρωση προϊόντων. Το πεδίο αυτό υποδεικνύει ότι υπάρχει κάποια ενημέρωση στα προϊόντα, και δεν θα πρέπει να έχει πάντα την τρέχουσα ημερομηνία.'
    },
    file_size: {
      en: 'Size and file type:',
      el: 'Μέγεθος και τύπος αρχείου'
    },
    accept_files: {
      en:
        'We can accept file types such as .xml or compressed formats like .zip and .gz.',
      el:
        'Οι τύποι αρχείου που μπορούμε να δεχτούμε είναι .xml ή συμπιεσμένες μορφές .zip και .gz.'
    },
    total_size: {
      en: 'The total size of the file should not exceed 100 MB (uncompressed).',
      el:
        'Το συνολικό μέγεθος του αρχείου δεν πρέπει να υπερβαίνει τα 100 ΜΒ (ασυμπίεστο).'
    },
    num_of_classifieds: {
      en: 'The total number of classifieds should not exceed 60,000.',
      el: 'Ο συνολικός αριθμός αγγελιών να μην υπερβαίνει τις 60.000.'
    },
    bundle: {
      en:
        "If your catalog is larger than these limits, you'll need to create a bundle of files that meet the above restrictions and add them as references to a central file. The central file should have the most recent date, or else none of the individual files will be updated. The specifications for the individual files apply as described above. The central file should look something like this:",
      el:
        'Αν ο κατάλογος σας είναι μεγαλύτερος, τότε θα πρέπει να φτιάξετε μια δέσμη αρχείων που πληρούν τους παραπάνω περιορισμούς και να τους προσθέσετε σαν παραπομπές σε ένα κεντρικό αρχείο. Το κεντρικό αρχείο θα πρέπει να έχει την πιο πρόσφατη ημερομηνία, αλλιώς δε θα ενημερώνεται κανενα επιμέρους αρχείο. Για τα επιμέρους ισχύει ό,τι έχει οριστεί παραπάνω. Το κεντρικό αρχείο θα πρέπει να μοιάζει κάπως έτσι:'
    },
    cost: {
      en: 'Cost and Rules',
      el: 'Κόστος και κανόνες'
    },
    sync: {
      en:
        'The synchronization service does not have any cost. However, it is under some certain rules. When you manually list or modify a classified on the car.gr website, you are charged with some credits, the modification date of the classified is updated, pushing it to the top of the search results. However, in the synchronization service, data changes and classified renewals are two independent actions. You can make as many changes as you want for free, without consuming credits, but these changes will not update the modification date of the classified, and each new classified will start with an age of 20 days.',
      el:
        'Η υπηρεσία του συγχρονισμού δεν έχει κάποιο κόστος. Ωστόσο υπόκειται σε κάποιους κανόνες. Όταν κάνετε κάποια χειροκίνητη καταχώριση ή τροποποίηση αγγελίας από την σελίδα του car.gr χρεώνεστε κάποια credit, ενημερώνεται η ημερομηνία τροποποίησης της αγγελίας και ανεβαίνετε στην κορυφή των αποτελεσμάτων. Στην υπηρεσία του συγχρονισμού όμως, οι αλλαγές δεδομένων και οι ανανεώσεις αγγελιών είναι δύο <b>ανεξάρτητες</b> ενέργειες. Μπορείτε να κάνετε όσες αλλαγές θέλετε δωρεάν, χωρίς να καταναλώνονται credits, ωστόσο οι αλλαγές αυτές δεν ενημερώνουν την ημερομηνία τροποποίησης της αγγελίας και κάθε καινούρια αγγελία ξεκινάει με ηλικία 20 ημερών.'
    },
    renew: {
      en:
        'If you wish to renew your classifieds, you can implement the update_interval mechanism described below or from your Control Panel.You are not allowed to delete your catalog and re-import it with different codes.',
      el:
        'Εάν επιθυμείτε να ανανεώσετε τις αγγελίες σας, μπορείτε να υλοποιήσετε τον μηχανισμό update_interval που περιγράφεται παρακάτω ή από τον Πίνακα Ελέγχου σας. Δεν μπορείτε να διαγράφετε τον κατάλογο σας και να τον ξαναεισάγετε με άλλους κωδικούς.'
    },
    technical_reasons: {
      en:
        'For purely technical reasons, a fair use policy is enforced. If it is observed that you are making unnecessary use of the service or if your data presents a bad image in terms of validity (e.g., many dead photo URLs), there is a possibility that the service may temporarily operate with lower priority for you.',
      el:
        'Για καθαρά τεχνικούς λόγους επιβάλλεται και μια πολιτική ορθής χρήσης. Αν παρατηρηθεί ότι κάνετε άσκοπη χρήση της υπηρεσίας ή αν τα δεδομένα σας παρουσιάζουν μια κακή εικόνα όσον αφορά την εγκυρότητα τους (πχ πολλές νεκρές διευθύνσεις φωτογραφιών), τότε υπάρχει περίπτωση να λειτουργεί η υπηρεσία με μια χαμηλότερη προτεραιότητα για εσάς, προσωρινά.'
    },
    general_commerce: {
      en: 'General Commerce XML',
      el: 'XML γενικού εμπορίου'
    },
    full_support: {
      en: 'Fully supports Vehicles',
      el: 'Υποστηρίζει πλήρως Οχήματα'
    },
    only_bicycles: {
      en: 'Only bicycles',
      el: 'Μόνο ποδήλατα'
    },
    fully_supported: {
      en: 'Fully supported',
      el: 'Υποστηρίζονται πλήρως'
    },
    supported_without_brand_model: {
      en:
        "They are supported, but you cannot input fitting make-model (e.g., fit for VW Golf '08).",
      el:
        "Υποστηρίζονται, αλλά δεν μπορείτε να βάλετε μάρκα-μοντέλο εφαρμογής (πχ ότι ταιριάζει σε VW Golf του '08)"
    },
    category_mapping: {
      en: 'Category mapping',
      el: 'Αντιστοίχιση κατηγοριών'
    },
    in_advance: {
      en:
        'It needs to be done in advance by you, so that the identifiers of Car.gr are already in the file.',
      el:
        'Πρέπει να γίνει εκ των προτέρων από εσάς, ώστε στο αρχείο να υπάρχουν έτοιμα τα αναγνωριστικά του car.gr	'
    },
    done_afterwards: {
      en: 'It can be done afterwards with a special menu in your panel.',
      el: 'Μπορεί να γίνει εκ των υστέρων με ειδικό μενού στο πάνελ σας'
    },
    implementation_cost: {
      en: 'Implementation cost',
      el: 'Κόστος υλοποίησης'
    },
    custom_implementation: {
      en:
        'You may need a custom implementation, so you should contact the manufacturer of your website/e-shop.',
      el:
        'Πιθανόν να χρειαστείτε custom υλοποίηση, απευθυνθείτε στον κατασκευαστή της ιστοσελίδας/e-shop σας'
    },
    ready_and_operating: {
      en:
        'You might already have it ready and operating on some price comparison platform.',
      el:
        'Πιθανόν να το έχετε ήδη έτοιμο και να λειτουργεί σε κάποια πλατφόρμα σύγκρισης τιμών'
    },
    xsd_title: {
      en: 'XSD parts and vehicles',
      el: 'XSD ανταλακτικών και οχημάτων'
    },
    dealer_xml: {
      en: 'General commerce XML',
      el: 'XML γενικού εμπορίου'
    }
  })
})
